var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"review-section-container"},[_c('div',{staticClass:"review-section"},[_c('ContentWithSwiper',{staticClass:"review-rolling-component",attrs:{"component-type":'review',"content-infos":_vm.reviewSwiperInfos}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }